// src/components/pdf/GeneralStatsPage.jsx
import React from 'react';
import { Page, Text, View } from '@react-pdf/renderer';
import styles from './styles';
import ComparisonBar from './charts/ComparisonBar';

const GeneralStatsPage = ({ match, statsJ1, statsJ2 }) => {
  // FIX 1: Groupes de normalisation SÉPARÉS
  
  // Groupe 1: Service counts (Aces + Double fautes seulement)
  const serviceCountMax = Math.max(
    statsJ1.aces, statsJ2.aces,
    statsJ1.dfs, statsJ2.dfs
  );
  
  // Groupe 2: Points counts (Winners + Fautes directes + Total Points)
  const pointsCountMax = Math.max(
    statsJ1.totalPoints, statsJ2.totalPoints,
    statsJ1.winners, statsJ2.winners,
    statsJ1.unForcedErrors, statsJ2.unForcedErrors
  );
  
  // Groupe 3: Détails fautes directes
  const errorsCountMax = Math.max(
    statsJ1.netErrors, statsJ2.netErrors,
    statsJ1.wideErrors, statsJ2.wideErrors,
    statsJ1.longErrors, statsJ2.longErrors
  );
  
  // Groupe 4: Jeux
  const gamesCountMax = Math.max(
    statsJ1.gamesWon, statsJ2.gamesWon,
    statsJ1.gamesServing, statsJ2.gamesServing,
    statsJ1.gamesReturning, statsJ2.gamesReturning
  );
  
  // Helper calcul % effets
  const effPct = (statsJ, serveKey, effCode, field, fieldWon) => {
    const ez = statsJ.effectStats?.[serveKey]?.[effCode] || {};
    const total = ez[field] || 0;
    const won = ez[fieldWon] || 0;
    return { pct: total > 0 ? Math.round((won / total) * 100) : 0, total };
  };

  // Helper calcul % effets+zones
  const effZonePct = (statsJ, serveKey, effCode, zCode) => {
    const ez = statsJ.effectZoneStats?.[serveKey]?.[effCode] || {};
    const total = ez[zCode] || 0;
    const won = ez[`${zCode}Won`] || 0;
    return { pct: total > 0 ? Math.round((won / total) * 100) : 0, total };
  };

  // Détecter si des données effets/zones existent
  const hasEffetsData = ['P','S','L'].some(eff =>
    (statsJ1.effectStats?.first?.[eff]?.first || 0) > 0 ||
    (statsJ2.effectStats?.first?.[eff]?.first || 0) > 0 ||
    (statsJ1.effectStats?.second?.[eff]?.second || 0) > 0 ||
    (statsJ2.effectStats?.second?.[eff]?.second || 0) > 0
  );
  const hasEffetsZonesData = ['P','S','L'].some(eff =>
    ['z1','z2','z3','z4','z5','z6'].some(z =>
      (statsJ1.effectZoneStats?.first?.[eff]?.[z] || 0) > 0 ||
      (statsJ2.effectZoneStats?.first?.[eff]?.[z] || 0) > 0 ||
      (statsJ1.effectZoneStats?.second?.[eff]?.[z] || 0) > 0 ||
      (statsJ2.effectZoneStats?.second?.[eff]?.[z] || 0) > 0
    )
  );

  return (
    <>
      {/* PAGE 2 : SERVICE avec zones côte à côte */}
      <Page size="A4" style={styles.page}>
        <Text style={styles.sectionTitle}>Statistiques Générales - Services</Text>
        <View style={{ height: 8 }} />

        {/* SERVICE */}
        <View style={[styles.subsectionTitle, { marginTop: 8, alignItems: 'center' }]}>
          <Text style={{ fontSize: 12, fontWeight: 'bold' }}>SERVICE</Text>
        </View>

        <ComparisonBar
          label="Aces & Services gagnants"
          valueLeft={statsJ1.aces}
          valueRight={statsJ2.aces}
          groupMax={serviceCountMax}
        />

        <ComparisonBar
          label="Double fautes"
          valueLeft={statsJ1.dfs}
          valueRight={statsJ2.dfs}
          groupMax={serviceCountMax}
        />

        <ComparisonBar
          label="Balles de break sauvées"
          valueLeft={statsJ1.breakSavedPct}
          valueRight={statsJ2.breakSavedPct}
          maxLeft={statsJ1.breakPointsFaced}
          maxRight={statsJ2.breakPointsFaced}
          showPercentage={true}
        />

        <ComparisonBar
          label="% 1er service"
          valueLeft={statsJ1.firstPct}
          valueRight={statsJ2.firstPct}
          maxLeft={statsJ1.totalServeAttempts}
          maxRight={statsJ2.totalServeAttempts}
          showPercentage={true}
        />

        <ComparisonBar
          label="% Points gagnés 1er service"
          valueLeft={statsJ1.firstWonPct}
          valueRight={statsJ2.firstWonPct}
          maxLeft={statsJ1.firstServes}
          maxRight={statsJ2.firstServes}
          showPercentage={true}
        />

        <ComparisonBar
          label="% Points gagnés 2nd service"
          valueLeft={statsJ1.secondWonPct}
          valueRight={statsJ2.secondWonPct}
          maxLeft={statsJ1.secondServes}
          maxRight={statsJ2.secondServes}
          showPercentage={true}
        />

        {/* FIX 4: Espacement avant les zones */}
        <View style={{ height: 12 }} />

        {/* FIX 4: Zones 1er et 2nd service côte à côte */}
        <View style={{ flexDirection: 'row', marginTop: 8, gap: 10 }}>
          {/* Colonne gauche : Zones 1er service */}
          <View style={{ flex: 1 }}>
            <Text style={{ 
              fontSize: 10, 
              fontWeight: 'bold', 
              color: '#000', 
              marginBottom: 4, 
              textAlign: 'center' 
            }}>
              % pts gagnés 1er service par zones
            </Text>
            
            {/* FIX 2: Espace après le titre */}
            <View style={{ height: 6 }} />

            <ComparisonBar
              label="Égalité"
              valueLeft={statsJ1.zoneStats.first.egalite > 0 ? Math.round((statsJ1.zoneStats.firstWon.egalite / statsJ1.zoneStats.first.egalite) * 100) : 0}
              valueRight={statsJ2.zoneStats.first.egalite > 0 ? Math.round((statsJ2.zoneStats.firstWon.egalite / statsJ2.zoneStats.first.egalite) * 100) : 0}
              maxLeft={statsJ1.zoneStats.first.egalite}
              maxRight={statsJ2.zoneStats.first.egalite}
              showPercentage={true}
              compact={true}
            />

            <ComparisonBar
              label="Avantage"
              valueLeft={statsJ1.zoneStats.first.avantage > 0 ? Math.round((statsJ1.zoneStats.firstWon.avantage / statsJ1.zoneStats.first.avantage) * 100) : 0}
              valueRight={statsJ2.zoneStats.first.avantage > 0 ? Math.round((statsJ2.zoneStats.firstWon.avantage / statsJ2.zoneStats.first.avantage) * 100) : 0}
              maxLeft={statsJ1.zoneStats.first.avantage}
              maxRight={statsJ2.zoneStats.first.avantage}
              showPercentage={true}
              compact={true}
            />

            <ComparisonBar
              label="Ext. égalité"
              valueLeft={statsJ1.zoneStats.first.z1 > 0 ? Math.round((statsJ1.zoneStats.firstWon.z1 / statsJ1.zoneStats.first.z1) * 100) : 0}
              valueRight={statsJ2.zoneStats.first.z1 > 0 ? Math.round((statsJ2.zoneStats.firstWon.z1 / statsJ2.zoneStats.first.z1) * 100) : 0}
              maxLeft={statsJ1.zoneStats.first.z1}
              maxRight={statsJ2.zoneStats.first.z1}
              showPercentage={true}
              compact={true}
            />

            <ComparisonBar
              label="Corps égalité"
              valueLeft={statsJ1.zoneStats.first.z2 > 0 ? Math.round((statsJ1.zoneStats.firstWon.z2 / statsJ1.zoneStats.first.z2) * 100) : 0}
              valueRight={statsJ2.zoneStats.first.z2 > 0 ? Math.round((statsJ2.zoneStats.firstWon.z2 / statsJ2.zoneStats.first.z2) * 100) : 0}
              maxLeft={statsJ1.zoneStats.first.z2}
              maxRight={statsJ2.zoneStats.first.z2}
              showPercentage={true}
              compact={true}
            />

            <ComparisonBar
              label="T égalité"
              valueLeft={statsJ1.zoneStats.first.z3 > 0 ? Math.round((statsJ1.zoneStats.firstWon.z3 / statsJ1.zoneStats.first.z3) * 100) : 0}
              valueRight={statsJ2.zoneStats.first.z3 > 0 ? Math.round((statsJ2.zoneStats.firstWon.z3 / statsJ2.zoneStats.first.z3) * 100) : 0}
              maxLeft={statsJ1.zoneStats.first.z3}
              maxRight={statsJ2.zoneStats.first.z3}
              showPercentage={true}
              compact={true}
            />

            <ComparisonBar
              label="T avantage"
              valueLeft={statsJ1.zoneStats.first.z4 > 0 ? Math.round((statsJ1.zoneStats.firstWon.z4 / statsJ1.zoneStats.first.z4) * 100) : 0}
              valueRight={statsJ2.zoneStats.first.z4 > 0 ? Math.round((statsJ2.zoneStats.firstWon.z4 / statsJ2.zoneStats.first.z4) * 100) : 0}
              maxLeft={statsJ1.zoneStats.first.z4}
              maxRight={statsJ2.zoneStats.first.z4}
              showPercentage={true}
              compact={true}
            />

            <ComparisonBar
              label="Corps avantage"
              valueLeft={statsJ1.zoneStats.first.z5 > 0 ? Math.round((statsJ1.zoneStats.firstWon.z5 / statsJ1.zoneStats.first.z5) * 100) : 0}
              valueRight={statsJ2.zoneStats.first.z5 > 0 ? Math.round((statsJ2.zoneStats.firstWon.z5 / statsJ2.zoneStats.first.z5) * 100) : 0}
              maxLeft={statsJ1.zoneStats.first.z5}
              maxRight={statsJ2.zoneStats.first.z5}
              showPercentage={true}
              compact={true}
            />

            <ComparisonBar
              label="Ext. avantage"
              valueLeft={statsJ1.zoneStats.first.z6 > 0 ? Math.round((statsJ1.zoneStats.firstWon.z6 / statsJ1.zoneStats.first.z6) * 100) : 0}
              valueRight={statsJ2.zoneStats.first.z6 > 0 ? Math.round((statsJ2.zoneStats.firstWon.z6 / statsJ2.zoneStats.first.z6) * 100) : 0}
              maxLeft={statsJ1.zoneStats.first.z6}
              maxRight={statsJ2.zoneStats.first.z6}
              showPercentage={true}
              compact={true}
            />
          </View>

          {/* FIX 3: Séparation verticale */}
          <View style={{ 
            width: 1, 
            backgroundColor: '#ccc', 
            marginHorizontal: 5 
          }} />

          {/* Colonne droite : Zones 2nd service */}
          <View style={{ flex: 1 }}>
            <Text style={{ 
              fontSize: 10, 
              fontWeight: 'bold', 
              color: '#000', 
              marginBottom: 4, 
              textAlign: 'center' 
            }}>
              % pts gagnés 2nd service par zones
            </Text>

            {/* FIX 2: Espace après le titre */}
            <View style={{ height: 6 }} />

            <ComparisonBar
              label="Égalité"
              valueLeft={statsJ1.zoneStats.second.egalite > 0 ? Math.round((statsJ1.zoneStats.secondWon.egalite / statsJ1.zoneStats.second.egalite) * 100) : 0}
              valueRight={statsJ2.zoneStats.second.egalite > 0 ? Math.round((statsJ2.zoneStats.secondWon.egalite / statsJ2.zoneStats.second.egalite) * 100) : 0}
              maxLeft={statsJ1.zoneStats.second.egalite}
              maxRight={statsJ2.zoneStats.second.egalite}
              showPercentage={true}
              compact={true}
            />

            <ComparisonBar
              label="Avantage"
              valueLeft={statsJ1.zoneStats.second.avantage > 0 ? Math.round((statsJ1.zoneStats.secondWon.avantage / statsJ1.zoneStats.second.avantage) * 100) : 0}
              valueRight={statsJ2.zoneStats.second.avantage > 0 ? Math.round((statsJ2.zoneStats.secondWon.avantage / statsJ2.zoneStats.second.avantage) * 100) : 0}
              maxLeft={statsJ1.zoneStats.second.avantage}
              maxRight={statsJ2.zoneStats.second.avantage}
              showPercentage={true}
              compact={true}
            />

            <ComparisonBar
              label="Ext. égalité"
              valueLeft={statsJ1.zoneStats.second.z1 > 0 ? Math.round((statsJ1.zoneStats.secondWon.z1 / statsJ1.zoneStats.second.z1) * 100) : 0}
              valueRight={statsJ2.zoneStats.second.z1 > 0 ? Math.round((statsJ2.zoneStats.secondWon.z1 / statsJ2.zoneStats.second.z1) * 100) : 0}
              maxLeft={statsJ1.zoneStats.second.z1}
              maxRight={statsJ2.zoneStats.second.z1}
              showPercentage={true}
              compact={true}
            />

            <ComparisonBar
              label="Corps égalité"
              valueLeft={statsJ1.zoneStats.second.z2 > 0 ? Math.round((statsJ1.zoneStats.secondWon.z2 / statsJ1.zoneStats.second.z2) * 100) : 0}
              valueRight={statsJ2.zoneStats.second.z2 > 0 ? Math.round((statsJ2.zoneStats.secondWon.z2 / statsJ2.zoneStats.second.z2) * 100) : 0}
              maxLeft={statsJ1.zoneStats.second.z2}
              maxRight={statsJ2.zoneStats.second.z2}
              showPercentage={true}
              compact={true}
            />

            <ComparisonBar
              label="T égalité"
              valueLeft={statsJ1.zoneStats.second.z3 > 0 ? Math.round((statsJ1.zoneStats.secondWon.z3 / statsJ1.zoneStats.second.z3) * 100) : 0}
              valueRight={statsJ2.zoneStats.second.z3 > 0 ? Math.round((statsJ2.zoneStats.secondWon.z3 / statsJ2.zoneStats.second.z3) * 100) : 0}
              maxLeft={statsJ1.zoneStats.second.z3}
              maxRight={statsJ2.zoneStats.second.z3}
              showPercentage={true}
              compact={true}
            />

            <ComparisonBar
              label="T avantage"
              valueLeft={statsJ1.zoneStats.second.z4 > 0 ? Math.round((statsJ1.zoneStats.secondWon.z4 / statsJ1.zoneStats.second.z4) * 100) : 0}
              valueRight={statsJ2.zoneStats.second.z4 > 0 ? Math.round((statsJ2.zoneStats.secondWon.z4 / statsJ2.zoneStats.second.z4) * 100) : 0}
              maxLeft={statsJ1.zoneStats.second.z4}
              maxRight={statsJ2.zoneStats.second.z4}
              showPercentage={true}
              compact={true}
            />

            <ComparisonBar
              label="Corps avantage"
              valueLeft={statsJ1.zoneStats.second.z5 > 0 ? Math.round((statsJ1.zoneStats.secondWon.z5 / statsJ1.zoneStats.second.z5) * 100) : 0}
              valueRight={statsJ2.zoneStats.second.z5 > 0 ? Math.round((statsJ2.zoneStats.secondWon.z5 / statsJ2.zoneStats.second.z5) * 100) : 0}
              maxLeft={statsJ1.zoneStats.second.z5}
              maxRight={statsJ2.zoneStats.second.z5}
              showPercentage={true}
              compact={true}
            />

            <ComparisonBar
              label="Ext. avantage"
              valueLeft={statsJ1.zoneStats.second.z6 > 0 ? Math.round((statsJ1.zoneStats.secondWon.z6 / statsJ1.zoneStats.second.z6) * 100) : 0}
              valueRight={statsJ2.zoneStats.second.z6 > 0 ? Math.round((statsJ2.zoneStats.secondWon.z6 / statsJ2.zoneStats.second.z6) * 100) : 0}
              maxLeft={statsJ1.zoneStats.second.z6}
              maxRight={statsJ2.zoneStats.second.z6}
              showPercentage={true}
              compact={true}
            />
          </View>
        </View>
      </Page>

      {/* PAGE 4 : EFFETS DE SERVICE */}
      {hasEffetsData && (
      <Page size="A4" style={styles.page}>
        <Text style={styles.sectionTitle}>Statistiques Générales - Effets au Service</Text>
        <View style={{ height: 8 }} />

        {/* Effets 1er et 2nd service côte à côte */}
        <View style={{ flexDirection: 'row', marginTop: 8, gap: 10 }}>

          {/* Colonne gauche : Effets 1er service */}
          <View style={{ flex: 1 }}>
            <Text style={{ fontSize: 10, fontWeight: 'bold', color: '#000', marginBottom: 4, textAlign: 'center' }}>
              % pts gagnés 1er service par effets
            </Text>
            <View style={{ height: 6 }} />

            {/* Plat global */}
            <Text style={{ fontSize: 8, color: '#555', marginBottom: 2, marginTop: 4 }}>Plat</Text>
            <ComparisonBar label="Global"
              valueLeft={effPct(statsJ1,'first','P','total','won').pct}
              valueRight={effPct(statsJ2,'first','P','total','won').pct}
              maxLeft={effPct(statsJ1,'first','P','total','won').total}
              maxRight={effPct(statsJ2,'first','P','total','won').total}
              showPercentage={true} compact={true}
            />
            <ComparisonBar label="Égalité"
              valueLeft={effPct(statsJ1,'first','P','egalite','egaliteWon').pct}
              valueRight={effPct(statsJ2,'first','P','egalite','egaliteWon').pct}
              maxLeft={effPct(statsJ1,'first','P','egalite','egaliteWon').total}
              maxRight={effPct(statsJ2,'first','P','egalite','egaliteWon').total}
              showPercentage={true} compact={true}
            />
            <ComparisonBar label="Avantage"
              valueLeft={effPct(statsJ1,'first','P','avantage','avantageWon').pct}
              valueRight={effPct(statsJ2,'first','P','avantage','avantageWon').pct}
              maxLeft={effPct(statsJ1,'first','P','avantage','avantageWon').total}
              maxRight={effPct(statsJ2,'first','P','avantage','avantageWon').total}
              showPercentage={true} compact={true}
            />

            {/* Slicé global */}
            <Text style={{ fontSize: 8, color: '#555', marginBottom: 2, marginTop: 6 }}>Slicé</Text>
            <ComparisonBar label="Global"
              valueLeft={effPct(statsJ1,'first','S','total','won').pct}
              valueRight={effPct(statsJ2,'first','S','total','won').pct}
              maxLeft={effPct(statsJ1,'first','S','total','won').total}
              maxRight={effPct(statsJ2,'first','S','total','won').total}
              showPercentage={true} compact={true}
            />
            <ComparisonBar label="Égalité"
              valueLeft={effPct(statsJ1,'first','S','egalite','egaliteWon').pct}
              valueRight={effPct(statsJ2,'first','S','egalite','egaliteWon').pct}
              maxLeft={effPct(statsJ1,'first','S','egalite','egaliteWon').total}
              maxRight={effPct(statsJ2,'first','S','egalite','egaliteWon').total}
              showPercentage={true} compact={true}
            />
            <ComparisonBar label="Avantage"
              valueLeft={effPct(statsJ1,'first','S','avantage','avantageWon').pct}
              valueRight={effPct(statsJ2,'first','S','avantage','avantageWon').pct}
              maxLeft={effPct(statsJ1,'first','S','avantage','avantageWon').total}
              maxRight={effPct(statsJ2,'first','S','avantage','avantageWon').total}
              showPercentage={true} compact={true}
            />

            {/* Lifté global */}
            <Text style={{ fontSize: 8, color: '#555', marginBottom: 2, marginTop: 6 }}>Lifté</Text>
            <ComparisonBar label="Global"
              valueLeft={effPct(statsJ1,'first','L','total','won').pct}
              valueRight={effPct(statsJ2,'first','L','total','won').pct}
              maxLeft={effPct(statsJ1,'first','L','total','won').total}
              maxRight={effPct(statsJ2,'first','L','total','won').total}
              showPercentage={true} compact={true}
            />
            <ComparisonBar label="Égalité"
              valueLeft={effPct(statsJ1,'first','L','egalite','egaliteWon').pct}
              valueRight={effPct(statsJ2,'first','L','egalite','egaliteWon').pct}
              maxLeft={effPct(statsJ1,'first','L','egalite','egaliteWon').total}
              maxRight={effPct(statsJ2,'first','L','egalite','egaliteWon').total}
              showPercentage={true} compact={true}
            />
            <ComparisonBar label="Avantage"
              valueLeft={effPct(statsJ1,'first','L','avantage','avantageWon').pct}
              valueRight={effPct(statsJ2,'first','L','avantage','avantageWon').pct}
              maxLeft={effPct(statsJ1,'first','L','avantage','avantageWon').total}
              maxRight={effPct(statsJ2,'first','L','avantage','avantageWon').total}
              showPercentage={true} compact={true}
            />
          </View>

          {/* Séparation verticale */}
          <View style={{ width: 1, backgroundColor: '#ccc', marginHorizontal: 4 }} />

          {/* Colonne droite : Effets 2nd service */}
          <View style={{ flex: 1 }}>
            <Text style={{ fontSize: 10, fontWeight: 'bold', color: '#000', marginBottom: 4, textAlign: 'center' }}>
              % pts gagnés 2nd service par effets
            </Text>
            <View style={{ height: 6 }} />

            <Text style={{ fontSize: 8, color: '#555', marginBottom: 2, marginTop: 4 }}>Plat</Text>
            <ComparisonBar label="Global"
              valueLeft={effPct(statsJ1,'second','P','total','won').pct}
              valueRight={effPct(statsJ2,'second','P','total','won').pct}
              maxLeft={effPct(statsJ1,'second','P','total','won').total}
              maxRight={effPct(statsJ2,'second','P','total','won').total}
              showPercentage={true} compact={true}
            />
            <ComparisonBar label="Égalité"
              valueLeft={effPct(statsJ1,'second','P','egalite','egaliteWon').pct}
              valueRight={effPct(statsJ2,'second','P','egalite','egaliteWon').pct}
              maxLeft={effPct(statsJ1,'second','P','egalite','egaliteWon').total}
              maxRight={effPct(statsJ2,'second','P','egalite','egaliteWon').total}
              showPercentage={true} compact={true}
            />
            <ComparisonBar label="Avantage"
              valueLeft={effPct(statsJ1,'second','P','avantage','avantageWon').pct}
              valueRight={effPct(statsJ2,'second','P','avantage','avantageWon').pct}
              maxLeft={effPct(statsJ1,'second','P','avantage','avantageWon').total}
              maxRight={effPct(statsJ2,'second','P','avantage','avantageWon').total}
              showPercentage={true} compact={true}
            />

            <Text style={{ fontSize: 8, color: '#555', marginBottom: 2, marginTop: 6 }}>Slicé</Text>
            <ComparisonBar label="Global"
              valueLeft={effPct(statsJ1,'second','S','total','won').pct}
              valueRight={effPct(statsJ2,'second','S','total','won').pct}
              maxLeft={effPct(statsJ1,'second','S','total','won').total}
              maxRight={effPct(statsJ2,'second','S','total','won').total}
              showPercentage={true} compact={true}
            />
            <ComparisonBar label="Égalité"
              valueLeft={effPct(statsJ1,'second','S','egalite','egaliteWon').pct}
              valueRight={effPct(statsJ2,'second','S','egalite','egaliteWon').pct}
              maxLeft={effPct(statsJ1,'second','S','egalite','egaliteWon').total}
              maxRight={effPct(statsJ2,'second','S','egalite','egaliteWon').total}
              showPercentage={true} compact={true}
            />
            <ComparisonBar label="Avantage"
              valueLeft={effPct(statsJ1,'second','S','avantage','avantageWon').pct}
              valueRight={effPct(statsJ2,'second','S','avantage','avantageWon').pct}
              maxLeft={effPct(statsJ1,'second','S','avantage','avantageWon').total}
              maxRight={effPct(statsJ2,'second','S','avantage','avantageWon').total}
              showPercentage={true} compact={true}
            />

            <Text style={{ fontSize: 8, color: '#555', marginBottom: 2, marginTop: 6 }}>Lifté</Text>
            <ComparisonBar label="Global"
              valueLeft={effPct(statsJ1,'second','L','total','won').pct}
              valueRight={effPct(statsJ2,'second','L','total','won').pct}
              maxLeft={effPct(statsJ1,'second','L','total','won').total}
              maxRight={effPct(statsJ2,'second','L','total','won').total}
              showPercentage={true} compact={true}
            />
            <ComparisonBar label="Égalité"
              valueLeft={effPct(statsJ1,'second','L','egalite','egaliteWon').pct}
              valueRight={effPct(statsJ2,'second','L','egalite','egaliteWon').pct}
              maxLeft={effPct(statsJ1,'second','L','egalite','egaliteWon').total}
              maxRight={effPct(statsJ2,'second','L','egalite','egaliteWon').total}
              showPercentage={true} compact={true}
            />
            <ComparisonBar label="Avantage"
              valueLeft={effPct(statsJ1,'second','L','avantage','avantageWon').pct}
              valueRight={effPct(statsJ2,'second','L','avantage','avantageWon').pct}
              maxLeft={effPct(statsJ1,'second','L','avantage','avantageWon').total}
              maxRight={effPct(statsJ2,'second','L','avantage','avantageWon').total}
              showPercentage={true} compact={true}
            />
          </View>
        </View>
      </Page>
      )}

      {/* PAGE 5 : EFFETS & ZONES DE SERVICE */}
      {hasEffetsZonesData && (
      <Page size="A4" style={styles.page}>
        <Text style={styles.sectionTitle}>Statistiques Générales - Effets & Zones de Service</Text>
        <View style={{ height: 8 }} />

        <View style={{ flexDirection: 'row', marginTop: 8, gap: 10 }}>

          {/* Colonne gauche : Effets & Zones 1er service */}
          <View style={{ flex: 1 }}>
            <Text style={{ fontSize: 10, fontWeight: 'bold', color: '#000', marginBottom: 4, textAlign: 'center' }}>
              % pts gagnés 1er service par effets & zones
            </Text>
            <View style={{ height: 6 }} />

            {['P','S','L'].map((eff, ei) => (
              <View key={eff} style={{ marginTop: ei > 0 ? 6 : 0 }}>
                <Text style={{ fontSize: 8, color: '#555', marginBottom: 2 }}>
                  {eff === 'P' ? 'Plat' : eff === 'S' ? 'Slicé' : 'Lifté'}
                </Text>
                {[
                  { zCode: 'z1', label: 'Ext. égalité' },
                  { zCode: 'z2', label: 'Corps égalité' },
                  { zCode: 'z3', label: 'T égalité' },
                  { zCode: 'z4', label: 'T avantage' },
                  { zCode: 'z5', label: 'Corps avantage' },
                  { zCode: 'z6', label: 'Ext. avantage' },
                ].map(({ zCode, label }) => (
                  <ComparisonBar key={zCode} label={label}
                    valueLeft={effZonePct(statsJ1,'first',eff,zCode).pct}
                    valueRight={effZonePct(statsJ2,'first',eff,zCode).pct}
                    maxLeft={effZonePct(statsJ1,'first',eff,zCode).total}
                    maxRight={effZonePct(statsJ2,'first',eff,zCode).total}
                    showPercentage={true} compact={true}
                  />
                ))}
              </View>
            ))}
          </View>

          {/* Séparation verticale */}
          <View style={{ width: 1, backgroundColor: '#ccc', marginHorizontal: 4 }} />

          {/* Colonne droite : Effets & Zones 2nd service */}
          <View style={{ flex: 1 }}>
            <Text style={{ fontSize: 10, fontWeight: 'bold', color: '#000', marginBottom: 4, textAlign: 'center' }}>
              % pts gagnés 2nd service par effets & zones
            </Text>
            <View style={{ height: 6 }} />

            {['P','S','L'].map((eff, ei) => (
              <View key={eff} style={{ marginTop: ei > 0 ? 6 : 0 }}>
                <Text style={{ fontSize: 8, color: '#555', marginBottom: 2 }}>
                  {eff === 'P' ? 'Plat' : eff === 'S' ? 'Slicé' : 'Lifté'}
                </Text>
                {[
                  { zCode: 'z1', label: 'Ext. égalité' },
                  { zCode: 'z2', label: 'Corps égalité' },
                  { zCode: 'z3', label: 'T égalité' },
                  { zCode: 'z4', label: 'T avantage' },
                  { zCode: 'z5', label: 'Corps avantage' },
                  { zCode: 'z6', label: 'Ext. avantage' },
                ].map(({ zCode, label }) => (
                  <ComparisonBar key={zCode} label={label}
                    valueLeft={effZonePct(statsJ1,'second',eff,zCode).pct}
                    valueRight={effZonePct(statsJ2,'second',eff,zCode).pct}
                    maxLeft={effZonePct(statsJ1,'second',eff,zCode).total}
                    maxRight={effZonePct(statsJ2,'second',eff,zCode).total}
                    showPercentage={true} compact={true}
                  />
                ))}
              </View>
            ))}
          </View>
        </View>
      </Page>
      )}

      {/* PAGE 3 : RETOUR + POINTS + JEUX */}
      <Page size="A4" style={styles.page}>
        <Text style={styles.sectionTitle}>Statistiques Générales - Retours, Points & Jeux</Text>
        <View style={{ height: 8 }} />

        {/* RETOUR */}
        <View style={[styles.subsectionTitle, { marginTop: 10, alignItems: 'center' }]}>
          <Text style={{ fontSize: 12, fontWeight: 'bold' }}>RETOUR</Text>
        </View>

        <ComparisonBar
          label="Balles de break converties"
          valueLeft={statsJ1.breakConvertedPct}
          valueRight={statsJ2.breakConvertedPct}
          maxLeft={statsJ1.breakPointsAgainst}
          maxRight={statsJ2.breakPointsAgainst}
          showPercentage={true}
        />

        <ComparisonBar
          label="% points gagnés retour 1er service"
          valueLeft={statsJ1.returnFirstPct}
          valueRight={statsJ2.returnFirstPct}
          maxLeft={statsJ1.returnFirst}
          maxRight={statsJ2.returnFirst}
          showPercentage={true}
        />

        <ComparisonBar
          label="% points gagnés retour 2nd service"
          valueLeft={statsJ1.returnSecondPct}
          valueRight={statsJ2.returnSecondPct}
          maxLeft={statsJ1.returnSecond}
          maxRight={statsJ2.returnSecond}
          showPercentage={true}
        />

        {/* POINTS */}
        <View style={[styles.subsectionTitle, { marginTop: 12, alignItems: 'center' }]}>
          <Text style={{ fontSize: 12, fontWeight: 'bold' }}>POINTS</Text>
        </View>

        <ComparisonBar
          label="Total points gagnés"
          valueLeft={statsJ1.totalPoints}
          valueRight={statsJ2.totalPoints}
          groupMax={pointsCountMax}
        />

        <ComparisonBar
          label="Total nb points gagnants"
          valueLeft={statsJ1.winners}
          valueRight={statsJ2.winners}
          groupMax={pointsCountMax}
        />

        <ComparisonBar
          label="% points gagnés au service"
          valueLeft={statsJ1.serviceWonPct}
          valueRight={statsJ2.serviceWonPct}
          maxLeft={statsJ1.totalServePoints}
          maxRight={statsJ2.totalServePoints}
          showPercentage={true}
        />

        <ComparisonBar
          label="% points gagnés au retour"
          valueLeft={statsJ1.returnWonPct}
          valueRight={statsJ2.returnWonPct}
          maxLeft={statsJ1.totalReturnPoints}
          maxRight={statsJ2.totalReturnPoints}
          showPercentage={true}
        />

        <ComparisonBar
          label="% points gagnés au filet"
          valueLeft={statsJ1.volleyWonPct}
          valueRight={statsJ2.volleyWonPct}
          maxLeft={statsJ1.volleyTotal}
          maxRight={statsJ2.volleyTotal}
          showPercentage={true}
        />

        <ComparisonBar
          label="Total nb fautes directes"
          valueLeft={statsJ1.unForcedErrors}
          valueRight={statsJ2.unForcedErrors}
          groupMax={pointsCountMax}
        />

        {/* Détails fautes directes */}
        <Text style={[styles.label, { marginTop: 8, fontSize: 9, color: '#666' }]}>
          Détails fautes directes
        </Text>

        <ComparisonBar
          label="Nb fautes directes filet"
          valueLeft={statsJ1.netErrors}
          valueRight={statsJ2.netErrors}
          groupMax={errorsCountMax}
        />

        <ComparisonBar
          label="Nb fautes directes couloir"
          valueLeft={statsJ1.wideErrors}
          valueRight={statsJ2.wideErrors}
          groupMax={errorsCountMax}
        />

        <ComparisonBar
          label="Nb fautes directes longueur"
          valueLeft={statsJ1.longErrors}
          valueRight={statsJ2.longErrors}
          groupMax={errorsCountMax}
        />

        {/* Points sous pression */}
        <Text style={[styles.label, { marginTop: 8, fontSize: 9, color: '#666' }]}>
          Points sous pression
        </Text>
        <ComparisonBar label="% balles de break sauvées"
          valueLeft={statsJ1.breakSavedPct} valueRight={statsJ2.breakSavedPct}
          maxLeft={statsJ1.breakPointsFaced} maxRight={statsJ2.breakPointsFaced}
          showPercentage={true} compact={true} />
        <ComparisonBar label="% balles de set sauvées"
          valueLeft={statsJ1.setPointsSavedPct} valueRight={statsJ2.setPointsSavedPct}
          maxLeft={statsJ1.setPointsFaced} maxRight={statsJ2.setPointsFaced}
          showPercentage={true} compact={true} />
        <ComparisonBar label="% balles de match sauvées"
          valueLeft={statsJ1.matchPointsSavedPct} valueRight={statsJ2.matchPointsSavedPct}
          maxLeft={statsJ1.matchPointsFaced} maxRight={statsJ2.matchPointsFaced}
          showPercentage={true} compact={true} />
        <ComparisonBar label="% pts gagnés à 40-40"
          valueLeft={statsJ1.equalityWonPct} valueRight={statsJ2.equalityWonPct}
          maxLeft={statsJ1.equalityPoints} maxRight={statsJ2.equalityPoints}
          showPercentage={true} compact={true} />
        <ComparisonBar label="% pts avantage (service)"
          valueLeft={statsJ1.advantageServingWonPct} valueRight={statsJ2.advantageServingWonPct}
          maxLeft={statsJ1.advantageServing} maxRight={statsJ2.advantageServing}
          showPercentage={true} compact={true} />
        <ComparisonBar label="% pts situation critique (serveur)"
          valueLeft={statsJ1.criticalServingWonPct} valueRight={statsJ2.criticalServingWonPct}
          maxLeft={statsJ1.criticalServing} maxRight={statsJ2.criticalServing}
          showPercentage={true} compact={true} />
        <ComparisonBar label="% pts situation critique (retourneur)"
          valueLeft={statsJ1.criticalReturningWonPct} valueRight={statsJ2.criticalReturningWonPct}
          maxLeft={statsJ1.criticalReturning} maxRight={statsJ2.criticalReturning}
          showPercentage={true} compact={true} />
        <ComparisonBar label="% jeux service favorables"
          valueLeft={statsJ1.favorableServeGamesWonPct} valueRight={statsJ2.favorableServeGamesWonPct}
          maxLeft={statsJ1.favorableServeGames} maxRight={statsJ2.favorableServeGames}
          showPercentage={true} compact={true} />
        <ComparisonBar label="% jeux retour favorables"
          valueLeft={statsJ1.favorableReturnGamesWonPct} valueRight={statsJ2.favorableReturnGamesWonPct}
          maxLeft={statsJ1.favorableReturnGames} maxRight={statsJ2.favorableReturnGames}
          showPercentage={true} compact={true} />
        <ComparisonBar label="% pts après 2 pts perdus"
          valueLeft={statsJ1.afterLossWonPct} valueRight={statsJ2.afterLossWonPct}
          maxLeft={statsJ1.afterLossTotal} maxRight={statsJ2.afterLossTotal}
          showPercentage={true} compact={true} />
        <ComparisonBar label="% pts après 2 pts gagnés"
          valueLeft={statsJ1.afterWinWonPct} valueRight={statsJ2.afterWinWonPct}
          maxLeft={statsJ1.afterWinTotal} maxRight={statsJ2.afterWinTotal}
          showPercentage={true} compact={true} />

        {/* JEUX */}
        <View style={[styles.subsectionTitle, { marginTop: 12, alignItems: 'center' }]}>
          <Text style={{ fontSize: 12, fontWeight: 'bold' }}>JEUX</Text>
        </View>

        <ComparisonBar
          label="Total de jeux gagnés"
          valueLeft={statsJ1.gamesWon}
          valueRight={statsJ2.gamesWon}
          groupMax={gamesCountMax}
        />

        <ComparisonBar
          label="Jeux de services gagnés"
          valueLeft={statsJ1.gamesServing}
          valueRight={statsJ2.gamesServing}
          groupMax={gamesCountMax}
        />

        <ComparisonBar
          label="Jeux de retours gagnés"
          valueLeft={statsJ1.gamesReturning}
          valueRight={statsJ2.gamesReturning}
          groupMax={gamesCountMax}
        />
      </Page>
      )}
    </>
  );
};

export default GeneralStatsPage;